<template>
  <ul class="news-list">
    <li class="news-list__item" v-for="item in items" :key="item.id">
      <SmartLink :route="`news/${item.slug}`" class="news-list__link">
        <div class="news-list__img-container">
          <NewsImage :src="item.image" class="news-list__img" />
        </div>
        <h3 class="news-list__title">{{ item.title }}</h3>
        <p class="news-list__date">{{ item.date }}</p>
      </SmartLink>
    </li>
  </ul>
</template>

<script>
import NewsImage from '../news-image';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: { NewsImage, SmartLink },
};
</script>

<style lang="scss" scoped>
.news-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 16px;
  align-items: stretch;

  &__item {
    display: flex;
    flex-direction: column;
    width: 23%;
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;

    &:not(:last-child) {
      margin-right: 16px;
    }

    @media (max-width: 1050px) {
      width: 48%;
      margin-bottom: 16px;

      &:not(:last-child) {
        margin-right: 0;
      }
    }

    @media (max-width: 550px) {
      width: 100%;
    }
  }

  &__link {
    width: 100%;
    height: 100%;
  }

  &__img-container {
    height: 170px;
    margin-bottom: 16px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__img {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    object-fit: cover;
  }

  &__title {
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    flex-grow: 1;
  }

  &__date {
    font-size: 12px;
    font-weight: 400;
    color: #71717A;
    margin-top: auto;
  }
}
</style>
